export default `# 使用cli工具
npm i widgets-cli -D
npx widgets-cli

# fetchAll下载商店所有部件，fetchOne下载指定部件
`;
